/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function () {
  // Add custom code below this line

  // ERODE — garde la bannière "Achetez X, obtenez Y% de réduction" du
  // panier synchronisée avec la quantité réelle du panier.
  //
  // Pourquoi : le thème Broadcast ne rafraîchit, après un ajout/retrait/
  // changement de quantité en AJAX, que le sous-total (priceHolder) et la
  // liste d'articles (itemsHolder) — voir assets/theme.js, méthode
  // CartItems.build(). La bannière promo est un bloc custom ajouté par
  // dessus et le thème ne sait pas qu'elle existe, donc elle ne se
  // mettait à jour qu'au rechargement de la page.
  //
  // Solution : on observe le priceHolder (qui, lui, EST rafraîchi à chaque
  // changement de panier par le thème) et, dès qu'il change, on récupère
  // la quantité à jour via /cart.js puis on recalcule et réécrit le texte
  // et la barre de progression de la bannière — exactement la même logique
  // que snippets/cart-promo-banner.liquid, côté client.

  function initCartPromoBannerSync() {
    var priceHolder = document.querySelector('[data-cart-price-holder]');
    var banner = document.querySelector('[data-cart-promo-banner]');

    if (!priceHolder || !banner) {
      return;
    }

    var observer = new MutationObserver(function () {
      refreshCartPromoBanner(banner);
    });

    observer.observe(priceHolder, { childList: true, subtree: true });
  }

  function refreshCartPromoBanner(banner) {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        updateCartPromoBanner(banner, cart.item_count);
      })
      .catch(function () {
        // Si l'appel échoue, la bannière garde son état précédent — elle
        // sera de toute façon recalculée au prochain changement de panier.
      });
  }

  function updateCartPromoBanner(banner, qty) {
    var tier1Qty = parseInt(banner.getAttribute('data-tier1-qty'), 10) || 0;
    var tier2Qty = parseInt(banner.getAttribute('data-tier2-qty'), 10) || 0;
    var tier1Message = banner.getAttribute('data-tier1-message') || '';
    var tier2Message = banner.getAttribute('data-tier2-message') || '';
    var completeMessage = banner.getAttribute('data-complete-message') || '';
    var defaultMessage = banner.getAttribute('data-default-message') || '';

    var text;
    var fillPercent;
    var state;

    if (qty <= 0) {
      text = defaultMessage;
      fillPercent = 0;
      state = 'empty';
    } else if (qty < tier1Qty) {
      text = tier1Message.replace('||remaining||', tier1Qty - qty);
      fillPercent = (qty * 100) / tier2Qty;
      state = 'tier1-progress';
    } else if (qty < tier2Qty) {
      text = tier2Message.replace('||remaining||', tier2Qty - qty);
      fillPercent = (qty * 100) / tier2Qty;
      state = 'tier1-complete';
    } else {
      text = completeMessage;
      fillPercent = 100;
      state = 'tier2-complete';
    }

    var textEl = banner.querySelector('.cart-promo-banner__text');
    var fillEl = banner.querySelector('.cart-promo-banner__fill');

    if (textEl) {
      textEl.textContent = text;
    }

    if (fillEl) {
      fillEl.style.width = fillPercent + '%';
    }

    banner.setAttribute('data-qty', qty);
    banner.className = banner.className.replace(
      /cart-promo-banner--(empty|tier1-progress|tier1-complete|tier2-complete)/,
      'cart-promo-banner--' + state
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartPromoBannerSync);
  } else {
    initCartPromoBannerSync();
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();